import { Stack, Text, textVariants } from '@etg/wings';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const InfoItem = ({
  title,
  children
}) => {
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 0,
    children: [/*#__PURE__*/_jsx(Text, {
      variant: textVariants._14_BOLD,
      children: title
    }), children]
  });
};
//# sourceMappingURL=InfoItem.js.map